import { Grid, useEventCallback } from '@mui/material';
import { PmiDatePicker } from 'shell/components/shared/date-picker';
import { Fragment, memo } from 'react';
import { DateTime } from 'luxon';
import PmiTextField from 'shell/components/shared/text-field';

interface ChooseDateProps {
  selected?: DateTime | null;
  required?: boolean;
  onChange: (value: DateTime | null) => void;
  disabled?: boolean;
  error?: boolean;
  label?: string;
  helperText?: string;
}

const ChooseDateComponent = ({
  selected = null,
  label = 'Data di nascita',
  onChange,
  required,
  disabled = false,
  error = false,
  helperText = '',
}: ChooseDateProps): React.ReactElement => {
  const onChangePicker = useEventCallback((date: DateTime | null) => {
    onChange(date);
  });

  return (
    <Fragment>
      <Grid item xs={12} md={disabled ? 12 : 6}>
        <PmiDatePicker
          label={required ? `${label} *` : label}
          value={selected}
          disabled={disabled}
          onChange={onChangePicker}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="choose-date-picker"
              fullWidth
              error={error}
              helperText={helperText}
            />
          )}
        />
      </Grid>
    </Fragment>
  );
};

ChooseDateComponent.displayName = 'Choose Date Person Filter Component without views date picker';

const ChooseDate = memo(ChooseDateComponent) as typeof ChooseDateComponent;

export default ChooseDate;
